import React, { useMemo } from 'react'
import injectSheet from 'react-jss'
import styles from './scroll-fade.styles'
import { usePresentation } from 'pobble-components/dist/presentation'
import { hexToRgb } from '../../utils'

const ScrollFade = ({ classes, color }) => {
  const { size, accessibilityColor, printMode } = usePresentation()

  const gradientColor = useMemo(() => {
    let result = '255, 255, 255'
    if (color) {
      const rgb = hexToRgb(color)
      result = `${rgb.r}, ${rgb.g}, ${rgb.b}`
    } else if (accessibilityColor !== 'none') {
      result = '251, 254, 184'
    }
    return result
  }, [accessibilityColor, color])

  return printMode ? null : (
    <div
      style={{
        background: `linear-gradient(0deg, rgba(${gradientColor},1) 0%, rgba(${gradientColor},0) 100%)`,
        height: size(6)
      }}
      className={classes.scrollFade}
    />
  )
}

export default injectSheet(styles)(ScrollFade)
